/*
 * containerGroups reducer
 */

// Constants
import { RESET_STATE } from '../auth/constants';
import {
    CONTAINER_GROUPS_SET,
    CONTAINER_GROUPS_MERGE,
    CONTAINER_GROUP_SET
} from './constants';
import { ContainerGroupState } from './types';

const initialState = {};

type State = {};

interface Action {
    type: string;
    payload: any;
}

export default function (
    state: State = initialState,
    action: Action
): ContainerGroupState {
    switch (action.type) {
        case CONTAINER_GROUPS_SET:
            return {
                ...action.payload
            };
        case CONTAINER_GROUPS_MERGE:
            return {
                ...state,
                ...action.payload
            };
        case CONTAINER_GROUP_SET:
            return {
                ...state,
                [action.payload.id]: action.payload
            };
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
